import { InputValue } from '@optimus-web/common';
import { MIN_MONTHLY_SALES_AMOUNT, MAX_FUNDING_AMOUNT, FUNDING_COEFFICIENTE } from './constants';

export const getAvailableFundingAmount = (value: InputValue) => {
    if (Number(value) < MIN_MONTHLY_SALES_AMOUNT) {
        return 0;
    }
    const funding = Number(value) * FUNDING_COEFFICIENTE;

    if (funding > MAX_FUNDING_AMOUNT) {
        return MAX_FUNDING_AMOUNT;
    }

    return Math.round(funding);
};
